window.inducteesGrid = function() {
    return {
        allItems: [],
        displayedItems: [],
        filteredItems: [],
        page: 1,
        perPage: 8,
        loading: false,
        isNameView: false,

        async init() {
            const initialData = JSON.parse(this.$el.dataset.initialItems);
            this.allItems = initialData.filter(group => group.profiles && group.profiles.length > 0);
            this.isNameView = this.$el.id === 'nameTab';

            if (this.isNameView) {
                this.applyNameFilter();
            } else {
                this.applyYearFilter();
            }

            this.$nextTick(() => {
                this.setupInfiniteScroll();
                if (this.isNameView) {
                    this.setupNameFilter();
                } else {
                    this.setupYearFilter();
                }
            });
        },

        setupYearFilter() {
            const yearFilter = document.getElementById('yearFilter');
            if (yearFilter) {
                yearFilter.addEventListener('change', (e) => {
                    const url = new URL(window.location.href);
                    if (e.target.value) {
                        url.searchParams.set('year', e.target.value);
                    } else {
                        url.searchParams.delete('year');
                    }
                    window.history.pushState({}, '', url.toString());
                    this.applyYearFilter();
                });
            }
        },

        applyYearFilter() {
            const queryParams = new URLSearchParams(window.location.search);
            const selectedYear = queryParams.get('year');

            if (selectedYear) {
                this.filteredItems = this.allItems.filter(item => item.year === selectedYear);
            } else {
                this.filteredItems = [...this.allItems];
            }

            // Reset pagination and update display
            this.page = 1;
            this.displayedItems = this.filteredItems.slice(0, this.perPage);
        },

        setupInfiniteScroll() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.loading) {
                        this.loadMore();
                    }
                });
            }, { rootMargin: '100px' });

            const sentinel = document.createElement('div');
            sentinel.className = 'scroll-sentinel';
            this.$el.appendChild(sentinel);
            observer.observe(sentinel);
        },

        async loadMore() {
            if (this.loading || this.displayedItems.length >= this.filteredItems.length) return;

            this.loading = true;
            await new Promise(resolve => setTimeout(resolve, 500));

            const start = this.page * this.perPage;
            const end = start + this.perPage;
            const newItems = this.filteredItems.slice(start, end);

            this.displayedItems = [...this.displayedItems, ...newItems];
            this.page++;
            this.loading = false;
        },

        applyNameFilter() {
            const queryParams = new URLSearchParams(window.location.search);
            const searchTerm = queryParams.get('search')?.toLowerCase();

            if (searchTerm) {
                this.filteredItems = this.allItems
                    .map(letterGroup => ({
                        letter: letterGroup.letter,
                        profiles: letterGroup.profiles.filter(profile =>
                            profile.profile.name.toLowerCase().includes(searchTerm)
                        )
                    }))
                    .filter(group => group.profiles.length > 0);
            } else {
                this.filteredItems = [...this.allItems];
            }

            this.page = 1;
            this.displayedItems = this.filteredItems.slice(0, this.perPage);
        },

        setupNameFilter() {
            const nameFilter = document.getElementById('nameFilter');
            if (nameFilter) {
                nameFilter.addEventListener('input', (e) => {
                    const url = new URL(window.location.href);
                    if (e.target.value) {
                        url.searchParams.set('search', e.target.value);
                    } else {
                        url.searchParams.delete('search');
                    }
                    window.history.pushState({}, '', url.toString());
                    this.applyNameFilter();
                });
            }
        }
    }
};